// src/utils/roles.js
// Who counts as ReVisionari staff, in one place.
//
// Read BOTH shapes, and that is not belt-and-braces. The user object reaches the frontend
// from two sources that disagree:
//
//   * /api/me (backend/app.py) returns `role` — a single string, no array.
//   * AuthContext stores `roles: u.roles || []`, which is therefore always [] in practice,
//     alongside `role`.
//
// A check written against `roles` alone is always false in production, however well it
// works against a hand-written fixture. That shipped once already: the blog studio told
// actual reviewers it was "for ReVisionari staff".
//
// Mirrors AUTHOR_ROLES in backend/routes/blog.py. The frontend copy only decides what is
// SHOWN — @require_role on the endpoints is the gate that matters.

export const AUTHOR_ROLES = ['reviewer', 'lead_reviewer', 'admin'];

/** Every role this user holds, from whichever field carries it. */
export function rolesOf(user) {
  if (!user) return [];
  const list = Array.isArray(user.roles) ? user.roles : [];
  return list.length ? list : [user.role].filter(Boolean);
}

/** True when the user may write blog posts. */
export function isBlogAuthor(user) {
  return rolesOf(user).some((r) => AUTHOR_ROLES.includes(r));
}
